import { service } from '@ember/service';

import BaseAbility from 'umg-ember-backend/abilities/base';

export default class ArtistAbility extends BaseAbility {
  // Services
  @service filter;

  // Getter and setter
  get canCreate() {
    return this.actions?.create && this.modelIsglobalArtist;
  }

  get canDelete() {
    return this.actions?.delete && this.modelIsglobalArtist;
  }

  get canRead() {
    return this.actions?.read && this.modelIsglobalArtist;
  }

  get canUpdate() {
    return this.actions?.update && this.modelIsglobalArtist;
  }

  get canUnlockEntity() {
    return this.actions?.unlockEntity;
  }

  get canBlockEntity() {
    return this.actions?.blockEntity;
  }

  get canViewMmcRms() {
    return this.permissions?.options?.canViewMmcRms ?? true;
  }

  get modelIsglobalArtist() {
    if (!this.filter.globalArtist || !this.model) {
      return true;
    }

    return this.filter.globalArtist.get('id') === this.model.get('id');
  }
}
